import { get, post, put } from "./api_helper"

// branches
const getListPage = params => get("admin/master/correction/page", params)
const getDetail = id => get(`admin/master/correction/${id}`)
const putData = params => put(`admin/master/correction/${params.id}`, params)
const postData = params => post(`admin/master/correction`, params)
const getList = params => get(`admin/master/correction/list`, params)

const correctionAPI = {
  getListPage,
  getDetail,
  postData,
  putData,
  getList,
}

export default correctionAPI
